import React, { useEffect, useState } from "react";
import Banner from "./../banner/banner";
import LeftSponsers from "./../leftSponsers/leftSponsers";
import * as api from "./../../api/api";
import * as c from "./../../const";

//BACKDROP STYLING
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

//ICONS
import LanguageIcon from "@material-ui/icons/Language";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
    backgroundColor: "white",
  },
}));

export default function Gallery(props) {
  const classes = useStyles();
  const [gallery, setGallery] = useState("");
  const [loader, setLoader] = useState(true);
  const [banner, setBanner] = useState("");

  useEffect(() => {
    document.title = "121five.com - Gallery";
    window.scrollTo(0, 0);
    photographerGalleryApi();
  }, []);

  const photographerGalleryApi = async () => {
    try {
      const id = props.match.params.id;
      let response = await api.photographerGallery(id);
      let res = await api.banner(3);
      if (res) {
        setBanner(res.image);
      }
      setGallery(response);
      setLoader(false);
    } catch (e) {}
  };

  return (
    <div>
      <Banner img={banner} />
      <section className="sponsor py-5">
        <div className="container">
          <div className="row justify-content-lg-between justify-content-center">
            <div className="col-lg-3 col-md-6">
              <div className="left-sponsor">
                <LeftSponsers />
              </div>
            </div>
            <div className="col-lg-9 col-md-12">
              <div id="lightbox" className="lightbox py-5">
                <div className="container">
                  <div className="row mb-3">
                    <div className="col-md-10 mx-auto text-center">
                      <div className="headline">
                        <h2>Our Recent Works</h2>
                        <p>Please take a look at some of them.</p>
                      </div>
                    </div>
                  </div>
                  <div className="lightbox_gallery">
                    <div className="row flex-start">
                      {Object.keys(gallery).map((index) => {
                        const url = c.URL;
                        let src = `${url}/${gallery[index].image}`;
                        let website = gallery[index].url;
                        return (
                          <div className="col-lg-4 col-md-6">
                            <div className="portfolioIcon">
                              <a
                                className="fancybox-buttons"
                                data-fancybox-group="button"
                                href={src}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <img
                                  src={src}
                                  className="img-fluid"
                                  alt="gallery"
                                />
                                <div className="galleryOverlay"> </div>
                                <div className="linkIcon">
                                  {" "}
                                  <i className="fas fa-search-plus"></i>{" "}
                                </div>
                              </a>
                              <div className="portfolio-body">
                                <h5>{gallery[index].title}</h5>
                                <p>
                                  <div>
                                    Website :
                                    <a
                                      href={website}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      <LanguageIcon color="primary" />
                                    </a>
                                  </div>
                                </p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Backdrop className={classes.backdrop} open={loader}>
          <CircularProgress />
        </Backdrop>
      </section>
    </div>
  );
}
